<template>
  <div v-if="informationRole">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('gestionRole.visualisation.title') + informationRole.name}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button" @click="$router.push({ name: 'l.parametrage.roles' })">
              {{ $t('detail.buttons.cancel') }}
            </button>
            <button class="button is-addOrEdit"
                    :class="{
                   'button-access-no-permission' : !checkPermissions(permsRoles.maj)
                   }"
                    @click="goEditRole()">
              {{ $t('detail.buttons.edit') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="columns">
      <div class="card column is-10 is-paddingless">
        <header class="header-card">
          <p> {{ $t('gestionRole.role')}} </p>
        </header>
        <div class="card-content is-marginless">
          <div class="columns">
            <b-field class="column is-3" :label="$t('gestionRole.libelle')">
              <span>{{ informationRole.name }}</span>
            </b-field>
            <b-field class="column is-9" :label="$t('gestionRole.description')">
              <span>{{ informationRole.description }}</span>
            </b-field>
          </div>
          <app-role-manager :allPermission="allPermissionsExisting"
                            :disable="true">
          </app-role-manager>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import genererRole from '@/services/role/genererRole';
import breadcrumb from '@/components/general/breadcrumb';
import { getRoleForEdit } from '@/api/role/index';
import transfertCategoriePermission from '@/services/role/transfertCategoriePermissions';
import generationTableauDesRoles from '@/services/role/generationTableauDesRoles';
import roleManager from '@/components/role/roleManager';
import { MODULES, DROITS, CATEGORIE_TO_TRANSFERT } from '@/configuration/role/roleManagerConf';
import mergePermission from '@/services/role/mergePermission';
import { ROLES } from '@/configuration/general/permissionsParametrageConf';

const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'c_detailRole',
  data() {
    return {
      informationRole: genererRole(),
      allPermissionsExisting: [],
      permissionDuRole: [],
      permsRoles: ROLES,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    appRoleManager: roleManager,
  },
  methods: {
    goEditRole() {
      this.$router.push({ name: 'm.parametrage.roles-edit', params: { id: this.$route.params.id } });
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('role.title'), route: { name: 'l.parametrage.roles' }, isActive: false },
        { title: this.$t('gestionRole.visualisation.title') + this.informationRole.name, route: '', isActive: true },
      ];
    },
  },
  async beforeMount() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const informationDuRole = (await getRoleForEdit(this.$route.params.id)).data.result;
      this.allPermissionsExisting = await generationTableauDesRoles(
        informationDuRole.permissions,
        MODULES,
        DROITS,
      );
      this.informationRole = informationDuRole.role;
      this.permissionDuRole = informationDuRole.grantedPermissionNames;
      transfertCategoriePermission(this.allPermissionsExisting,
        CATEGORIE_TO_TRANSFERT);
      this.allPermissionsExisting = mergePermission(
        this.allPermissionsExisting,
        this.permissionDuRole,
      );
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.informationRole.name }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
